import React, { useEffect, useState } from "react"
import ReactiveBase from "@appbaseio/reactivesearch/lib/components/basic/ReactiveBase"
import ReactiveComponent from "@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"
import ReactiveList from "@appbaseio/reactivesearch/lib/components/result/ReactiveList"
import SingleList from "@appbaseio/reactivesearch/lib/components/list/SingleList"
import MultiList from "@appbaseio/reactivesearch/lib/components/list/MultiList"
import DynamicRangeSlider from "@appbaseio/reactivesearch/lib/components/range/DynamicRangeSlider"
import SingleRange from "@appbaseio/reactivesearch/lib/components/range/SingleRange"
import SelectedFilters from "@appbaseio/reactivesearch/lib/components/basic/SelectedFilters"
import DataSearch from "@appbaseio/reactivesearch/lib/components/search/DataSearch"

export const SearchProvider = ({ config, children }): JSX.Element => {
  const [renderKey, setRenderKey] = useState(0)

  const handleRefresh = () => setRenderKey(prev => prev + 1)

  useEffect(() => {
    window.addEventListener("refreshSearch", handleRefresh)
    return () => window.removeEventListener("refreshSearch", handleRefresh)
  }, [])

  return (
    <ReactiveBase
      key={renderKey}
      url={`${config?.searchUrl}`}
      app={config?.searchIndex}
      theme={{
        typography: {
          fontFamily: "inherit",
        },
        colors: {
          textColor: "#000",
          backgroundColor: "#fff",
          primaryTextColor: "#000",
          primaryColor: "#000",
          titleColor: "#000",
          alertColor: "#D84129",
          borderColor: "#000",
        },
      }}
    >
      {children}
    </ReactiveBase>
  )
}
export const SearchComponents = {
  ReactiveBase,
  ReactiveComponent,
  ReactiveList,
  SingleList,
  MultiList,
  DynamicRangeSlider,
  SingleRange,
  SelectedFilters,
  DataSearch,
}
